/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Misc_Discordlinked_Body1Inputs */

const id_misc_discordlinked_body1 = /** @type {(inputs: Misc_Discordlinked_Body1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Akun Discord Anda telah berhasil ditautkan ke egdata.app`)
};

const ms_misc_discordlinked_body1 = /** @type {(inputs: Misc_Discordlinked_Body1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Akaun Discord anda telah berjaya dipautkan ke egdata.app`)
};

const da_misc_discordlinked_body1 = /** @type {(inputs: Misc_Discordlinked_Body1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Din Discord-konto er blevet succesfuldt linket til egdata.app`)
};

const de_misc_discordlinked_body1 = /** @type {(inputs: Misc_Discordlinked_Body1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ihr Discord-Konto wurde erfolgreich mit egdata.app verknüpft`)
};

const en_us2_misc_discordlinked_body1 = /** @type {(inputs: Misc_Discordlinked_Body1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Your Discord account has been successfully linked to egdata.app`)
};

const es_es2_misc_discordlinked_body1 = /** @type {(inputs: Misc_Discordlinked_Body1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tu cuenta de Discord se ha vinculado correctamente a egdata.app`)
};

const es_mx2_misc_discordlinked_body1 = /** @type {(inputs: Misc_Discordlinked_Body1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tu cuenta de Discord se ha vinculado exitosamente a egdata.app`)
};

const fil_misc_discordlinked_body1 = /** @type {(inputs: Misc_Discordlinked_Body1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ang iyong Discord account ay matagumpay na na-link sa egdata.app`)
};

const fr_misc_discordlinked_body1 = /** @type {(inputs: Misc_Discordlinked_Body1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Votre compte Discord a été lié avec succès à egdata.app`)
};

const it_misc_discordlinked_body1 = /** @type {(inputs: Misc_Discordlinked_Body1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Il tuo account Discord è stato collegato con successo a egdata.app`)
};

const hu_misc_discordlinked_body1 = /** @type {(inputs: Misc_Discordlinked_Body1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Discord fiókod sikeresen össze lett kapcsolva az egdata.app-pal`)
};

const nl_misc_discordlinked_body1 = /** @type {(inputs: Misc_Discordlinked_Body1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Je Discord-account is succesvol gekoppeld aan egdata.app`)
};

const no_misc_discordlinked_body1 = /** @type {(inputs: Misc_Discordlinked_Body1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Discord-kontoen din har blitt koblet til egdata.app`)
};

const pl_misc_discordlinked_body1 = /** @type {(inputs: Misc_Discordlinked_Body1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Twoje konto Discord zostało pomyślnie połączone z egdata.app`)
};

const pt_br2_misc_discordlinked_body1 = /** @type {(inputs: Misc_Discordlinked_Body1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sua conta Discord foi vinculada com sucesso a egdata.app`)
};

const pt_misc_discordlinked_body1 = /** @type {(inputs: Misc_Discordlinked_Body1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A sua conta Discord foi vinculada com sucesso ao egdata.app`)
};

const ro_misc_discordlinked_body1 = /** @type {(inputs: Misc_Discordlinked_Body1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Contul tău Discord a fost asociat cu succes cu egdata.app`)
};

const fi_misc_discordlinked_body1 = /** @type {(inputs: Misc_Discordlinked_Body1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Discord-tilisi on linkitetty onnistuneesti egdata.appiin`)
};

const sv_misc_discordlinked_body1 = /** @type {(inputs: Misc_Discordlinked_Body1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ditt Discord-konto har länkats till egdata.app`)
};

const vi_misc_discordlinked_body1 = /** @type {(inputs: Misc_Discordlinked_Body1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tài khoản Discord của bạn đã được liên kết thành công với egdata.app`)
};

const tr_misc_discordlinked_body1 = /** @type {(inputs: Misc_Discordlinked_Body1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Discord hesabınız egdata.app'a başarıyla bağlandı`)
};

const cs_misc_discordlinked_body1 = /** @type {(inputs: Misc_Discordlinked_Body1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Váš Discord účet byl úspěšně propojen s egdata.app`)
};

const bg_misc_discordlinked_body1 = /** @type {(inputs: Misc_Discordlinked_Body1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Вашият Discord акаунт беше успешно свързан с egdata.app`)
};

const ru_misc_discordlinked_body1 = /** @type {(inputs: Misc_Discordlinked_Body1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ваша учётная запись Discord успешно привязана к egdata.app`)
};

const uk_misc_discordlinked_body1 = /** @type {(inputs: Misc_Discordlinked_Body1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ваш обліковий запис Discord успішно прив'язано до egdata.app`)
};

const ar_misc_discordlinked_body1 = /** @type {(inputs: Misc_Discordlinked_Body1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`تم ربط حساب Discord الخاص بك بـ egdata.app بنجاح`)
};

const hi_misc_discordlinked_body1 = /** @type {(inputs: Misc_Discordlinked_Body1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`आपका Discord खाता egdata.app से लिंक कर दिया गया है`)
};

const th_misc_discordlinked_body1 = /** @type {(inputs: Misc_Discordlinked_Body1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`บัญชี Discord ของคุณเชื่อมต่อกับ egdata.app สำเร็จแล้ว`)
};

const ja_misc_discordlinked_body1 = /** @type {(inputs: Misc_Discordlinked_Body1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Discord アカウントが egdata.app に正常に連携されました`)
};

const zh_cn2_misc_discordlinked_body1 = /** @type {(inputs: Misc_Discordlinked_Body1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`你的 Discord 账号已成功关联到 egdata.app`)
};

const zh_hant1_misc_discordlinked_body1 = /** @type {(inputs: Misc_Discordlinked_Body1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`你的 Discord 帳號已成功關聯到 egdata.app`)
};

const ko_misc_discordlinked_body1 = /** @type {(inputs: Misc_Discordlinked_Body1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Discord 계정이 egdata.app에 성공적으로 연결되었습니다.`)
};

/**
* | output |
* | --- |
* | "Your Discord account has been successfully linked to egdata.app" |
*
* @param {Misc_Discordlinked_Body1Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const misc_discordlinked_body1 = /** @type {((inputs?: Misc_Discordlinked_Body1Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Misc_Discordlinked_Body1Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_misc_discordlinked_body1(inputs)
	if (locale === "ms") return ms_misc_discordlinked_body1(inputs)
	if (locale === "da") return da_misc_discordlinked_body1(inputs)
	if (locale === "de") return de_misc_discordlinked_body1(inputs)
	if (locale === "en-US") return en_us2_misc_discordlinked_body1(inputs)
	if (locale === "es-ES") return es_es2_misc_discordlinked_body1(inputs)
	if (locale === "es-MX") return es_mx2_misc_discordlinked_body1(inputs)
	if (locale === "fil") return fil_misc_discordlinked_body1(inputs)
	if (locale === "fr") return fr_misc_discordlinked_body1(inputs)
	if (locale === "it") return it_misc_discordlinked_body1(inputs)
	if (locale === "hu") return hu_misc_discordlinked_body1(inputs)
	if (locale === "nl") return nl_misc_discordlinked_body1(inputs)
	if (locale === "no") return no_misc_discordlinked_body1(inputs)
	if (locale === "pl") return pl_misc_discordlinked_body1(inputs)
	if (locale === "pt-BR") return pt_br2_misc_discordlinked_body1(inputs)
	if (locale === "pt") return pt_misc_discordlinked_body1(inputs)
	if (locale === "ro") return ro_misc_discordlinked_body1(inputs)
	if (locale === "fi") return fi_misc_discordlinked_body1(inputs)
	if (locale === "sv") return sv_misc_discordlinked_body1(inputs)
	if (locale === "vi") return vi_misc_discordlinked_body1(inputs)
	if (locale === "tr") return tr_misc_discordlinked_body1(inputs)
	if (locale === "cs") return cs_misc_discordlinked_body1(inputs)
	if (locale === "bg") return bg_misc_discordlinked_body1(inputs)
	if (locale === "ru") return ru_misc_discordlinked_body1(inputs)
	if (locale === "uk") return uk_misc_discordlinked_body1(inputs)
	if (locale === "ar") return ar_misc_discordlinked_body1(inputs)
	if (locale === "hi") return hi_misc_discordlinked_body1(inputs)
	if (locale === "th") return th_misc_discordlinked_body1(inputs)
	if (locale === "ja") return ja_misc_discordlinked_body1(inputs)
	if (locale === "zh-CN") return zh_cn2_misc_discordlinked_body1(inputs)
	if (locale === "zh-Hant") return zh_hant1_misc_discordlinked_body1(inputs)
	return ko_misc_discordlinked_body1(inputs)
});
export { misc_discordlinked_body1 as "misc.discordLinked.body" }